module.exports = __webpack_public_path__ + "img/engineer-logo-fill-02-512b5fb94b24697b4af82219a7f43a62.568311f6.png";